import React from "react";
import * as F from "./PlanBoxCoachingPlus.style";
import * as G from "styles/General.Styles";
import GreenTickWhiteBg from "assets/images/Page2/Icon-check-green-white.svg";

const SinglePlan = ({ openLeadFormModal }) => {
  const list = [
    "Unverbindliches Erstgespräch",
    "Ernährungsplan mit eigener App",
    "Zugang zur Lernacademy",
    "12 Wochen Online-Kurs",
  ];

  return (
    <F.CoachingPlansBox className="plansBox">
      <F.PlanBox className="active">
        <F.PlanBoxHead>
          <F.TitleInfo className="active ct-text-block uppercase text-base font-normal">
            Coaching PLUS + Präventionskurs
          </F.TitleInfo>
          <F.Title className="ct-text-block color-dark text-4xl mb-12 font-medium">
            Ab 50,00 €
          </F.Title>
          <F.SubTitle className="ct-text-block uppercase text-base font-normal">
            Bis zu 100% Rückerstattung von deiner Krankenkasse.
          </F.SubTitle>
        </F.PlanBoxHead>
        <F.PlanLowerBox>
          <G.PlanBoxIcons>
            {list.map((item) => (
              <li>
                <G.PlanBoxIconBox>
                  <img src={GreenTickWhiteBg} alt="Tick" />
                </G.PlanBoxIconBox>
                <G.PlanBoxInformation className="ct-text-block text-base">
                  {item}
                </G.PlanBoxInformation>
              </li>
            ))}
          </G.PlanBoxIcons>
        </F.PlanLowerBox>
        <div className="button-wrapper">
          <button className="btn-dark" onClick={openLeadFormModal}>
            Erstgespräch vereinbaren
          </button>
        </div>
      </F.PlanBox>
    </F.CoachingPlansBox>
  );
};

export default SinglePlan;
